export default __webpack_public_path__ + "static/SanFranciscoText-Bold-caa5781cfe0d2c96b3ff3b84dbb81476.otf";